import React, { useEffect, useState } from "react";

const Testimonial = (props) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch data
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/testimonials`
        );
        const result = await response.json();
        console.log(result);

        const formattedData = result.data.map((item) => ({
          id: item.id,
          ...(item.attributes || item),
        }));

        setTestimonials(formattedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  if (loading) {
    return <p className="text-center text-gray-600">Loading testimonials...</p>;
  }

  return (
    <section className={`text-gray-600 body-font bg-${props.mode}`}>
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap -m-4">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="lg:w-1/3 lg:mb-0 mb-6 p-4">
              <div className="h-full text-center">
                <img
                  alt={testimonial.name}
                  className="w-20 h-20 mb-8 object-cover object-center rounded-full inline-block border-2 border-gray-200 bg-gray-100"
                  src={testimonial.image}
                />
                <p className="leading-relaxed">{testimonial.description}</p>
                <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-6 mb-4"></span>
                <h2
                  className={`text-${
                    props.mode === "black" ? "white" : "black"
                  } font-medium title-font tracking-wider text-sm`}
                >
                  {testimonial.name?.toUpperCase()}
                </h2>
                <p className="text-gray-500">{testimonial.designation}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
